// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Lc11l","alignToEdge":"Ay84-","buttonIcon":"MqDMZ","buttonCaption":"_5FLOI","buttonSpacer":"_5W04r"};